import React from 'react';

const FormLabel = (props) => {
  const { label, forId } = props;
  return (
    <label className="form-label" htmlFor={forId}>{label}</label>
  );
};

export default FormLabel;
